/**
 * NAT-2481 — the slow-mover list as XLSX: every wine the list's criteria match, not the ten on
 * screen, in the list's order. The criteria are fixed, so the preamble states them; the figures
 * are a position as of today.
 */
import type { IOrderProductItem } from 'src/types';
import { toFiniteNumber } from 'src/utils/strict-number';
import type { XlsxWorkbookSpec } from 'src/utils/file-downloader';
import { exportDay, exportTimestamp } from 'src/utils/get-date-worlds-format';

import { sheetOf, type ExportT } from '../position-export';
import { valueAtCost } from './slow-stock-value';

export function slowStockWorkbook({
  rows,
  page,
  shownTop,
  t,
  now = new Date(),
}: {
  rows: IOrderProductItem[];
  /** The page (and section) the list sits on, in the viewer's language. */
  page: string;
  /** How many the screen lists: the file says it holds all of them, not just those. */
  shownTop: number;
  t: ExportT;
  now?: Date;
}): XlsxWorkbookSpec {
  return {
    fileName: `${page} - ${t('titolo')}`,
    preamble: [
      [t('export_pagina'), page],
      [t('export_situazione_al'), exportDay(now)],
      [t('export_criteri'), t('export_criteri_valore')],
      [t('export_righe'), t('export_righe_tutte_top', { top: shownTop })],
      [t('export_ordinamento'), t('export_ordinamento_valore')],
      [t('export_esportato_il'), exportTimestamp(now)],
    ],
    sheets: [
      sheetOf<IOrderProductItem>(
        t('titolo'),
        [
          { header: t('col_vino'), kind: 'text', cell: (r) => r.full_name || r.name },
          { header: t('export_col_produttore'), kind: 'text', cell: (r) => r.producer_name },
          { header: 'SKU', kind: 'text', cell: (r) => r.sku },
          {
            header: t('col_bottiglie'),
            kind: 'integer',
            cell: (r) => toFiniteNumber(r.storage_quantity),
          },
          { header: t('col_valore'), kind: 'euro', cell: valueAtCost },
          {
            header: t('export_col_eta_giorni'),
            kind: 'integer',
            cell: (r) => toFiniteNumber(r.stock_age),
          },
        ],
        rows,
      ),
    ],
  };
}
